import { GetFullUserType } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useQuery } from '@tanstack/react-query'

export const useMe = () => {
	return useQuery<GetFullUserType>({
		queryKey: queryKeys.me(),
		queryFn: async () => {
			const response = await api.get<GetFullUserType>('/users')
			return response.data
		},
		retry: 1,
	})
}

